export default "__VITE_ASSET__DcVFatM5__"